import React from 'react';
import * as Progress from '@radix-ui/react-progress';
import { usePercentageConverter } from '~/shared/hooks/usePercentageConverter';
import styles from './ProgressBar.module.scss';

type ProgressBarProps = {
    progressValue: number;
    max: number;
};

export const ProgressBar = ({ progressValue, max }: ProgressBarProps) => {
    const progressPercentage = usePercentageConverter(progressValue, max);

    return (
        <Progress.Root
            className={styles.progressBarContainer}
            value={progressPercentage}
            max={100}
            role="progressbar"
            aria-label="Progress Bar"
        >
            <Progress.Indicator
                className={styles.progresBarIndicator}
                style={{ transform: `translateX(-${100 - progressPercentage}%)` }}
            />
        </Progress.Root>
    );
};
